module.exports = __webpack_public_path__ + "img/logo.0db36a84.png";